import React, { Component } from 'react';
import { connect } from "react-redux";
import Swal from 'sweetalert2';
import {changeSetting} from "../../../../actions/actions";

@connect((store) => {
    return {
        chatprop: store.chatprop
    };
})
class AdditionalSettings extends Component {

    constructor(props) {
        super(props);
        this.state={
            widget_show_agent_photo:this.props.chatprop.settings.widget_show_agent_photo,
            widget_show_agent_rate:this.props.chatprop.settings.widget_show_agent_rate,
            widget_show_department_select:this.props.chatprop.settings.widget_show_department_select

        }

        this.changeAgentPhoto=this.changeAgentPhoto.bind(this);
        this.changeAgentRate=this.changeAgentRate.bind(this);
        this.changeDepartmentSelect=this.changeDepartmentSelect.bind(this);
    }


    changeAgentRate(e){
        if(e.target.checked){
            var widget_show_agent_rate=1;
        } else{
            var widget_show_agent_rate=0;
        }
        this.setState({
            widget_show_agent_rate:widget_show_agent_rate
        });
        Swal.fire({
            showCancelButton: true,
            confirmButtonText: 'Save changes',
            reverseButtons: true
        }).then((result) => {
            if (result.isConfirmed) {
                this.props.dispatch(changeSetting({widget_show_agent_rate:widget_show_agent_rate}));
            } else{
                this.setState({
                    widget_show_agent_rate:!widget_show_agent_rate
                });
            }
        });
    }
    componentWillUnmount() {
        Swal.close();
    }
    changeDepartmentSelect(e){
        if(e.target.checked){
            var widget_show_department_select=1;
        } else{
            var widget_show_department_select=0;
        }
        this.setState({
            widget_show_department_select:widget_show_department_select
        });
        Swal.fire({
            showCancelButton: true,
            confirmButtonText: 'Save changes',
            reverseButtons: true
        }).then((result) => {
            if (result.isConfirmed) {
                this.props.dispatch(changeSetting({widget_show_department_select:widget_show_department_select}));
            } else{
                this.setState({
                    widget_show_department_select:!widget_show_department_select
                });
            }
        });

    }
    changeAgentPhoto(e){
        if(e.target.checked){
            var widget_show_agent_photo=1;
        } else{
            var widget_show_agent_photo=0;
        }
        this.setState({
            widget_show_agent_photo:widget_show_agent_photo
        });
        Swal.fire({
            showCancelButton: true,
            confirmButtonText: 'Save changes',
            reverseButtons: true
        }).then((result) => {
            if (result.isConfirmed) {
                this.props.dispatch(changeSetting({widget_show_agent_photo:widget_show_agent_photo}));
            } else{
                this.setState({
                    widget_show_agent_photo:!widget_show_agent_photo
                });
            }
        });

    }

    render() {
        const { t } = this.props;
        return (
            <React.Fragment>
                <div className="hv-setting-item-container">
                    <div className="hv-setting-item">
                        <div>
                            <span>Show agent’s photo</span>
                        </div>
                        <div className="settings-switch">
                            <label className="switch">
                                <input
                                    checked={this.state.widget_show_agent_photo == 1 ? true : false}
                                    onChange={e => this.changeAgentPhoto(e)}
                                    className="auto_assignment_change"
                                       type="checkbox"
                                     />
                                <span className="slider round"></span>
                            </label>
                        </div>
                    </div>

                    <div className="hv-setting-item">
                        <div>
                            <span>Let customers rate agents</span>
                        </div>
                        <div className="settings-switch">
                            <label className="switch">
                                <input
                                    checked={this.state.widget_show_agent_rate == 1 ? true : false}
                                    onChange={e => this.changeAgentRate(e)}
                                    className="auto_assignment_change"
                                    type="checkbox"
                                />
                                <span className="slider round"></span>
                            </label>
                        </div>
                    </div>
                    <div className="hv-setting-item">
                        <div>
                            <span>Show department selection</span>
                        </div>
                        <div className="settings-switch">
                            <label className="switch">
                                <input
                                    checked={this.state.widget_show_department_select == 1 ? true : false}
                                    onChange={e => this.changeDepartmentSelect(e)}
                                    className="auto_assignment_change"
                                    type="checkbox"
                                />
                                <span className="slider round"></span>
                            </label>
                        </div>
                    </div>

                </div>
            </React.Fragment>
        );
    }
}

export default AdditionalSettings;
